module.exports = __webpack_public_path__ + "img/logo.2b935f94.png";